import { useEffect, type RefObject } from 'react'

/** Calls `onOutside` on any pointer press outside `ref`, while `enabled`. */
export const useOutsidePointerDown = (
  ref: RefObject<HTMLElement | null>,
  enabled: boolean,
  onOutside: () => void
): void => {
  useEffect(() => {
    if (!enabled) {
      return
    }

    const onPointerDown = (event: PointerEvent): void => {
      const target = event.target

      if (target instanceof Node && ref.current?.contains(target)) {
        return
      }

      onOutside()
    }

    // Capture phase, so handlers that stop propagation can't hide the press
    document.addEventListener('pointerdown', onPointerDown, true)

    return () => document.removeEventListener('pointerdown', onPointerDown, true)
  }, [ref, enabled, onOutside])
}
